module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberschleissheim/04-cb096cd5bc367e9ec2b44d750bc03ad5.jpg";